import React, { useRef, useState, useEffect, useCallback, memo, PropsWithChildren } from 'react';
import { Input, Button } from 'tea-component';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { useAigcIntl } from '@/pages/aigc/utils/utils';

interface ChatInputProps extends PropsWithChildren<any> {
  showStop?: boolean;
  onSend: Function;
  onStop?: Function;
  minRows?: number;
  maxRows?: number;
  className?: string;
}

export default memo((props: ChatInputProps) => {
  const { formatMessage: text2sqlFormat } = useAigcIntl('text2sql');

  const {
    showStop,
    onSend, // 发送按钮事件
    onStop, // 停止按钮事件
    minRows = 1,
    maxRows = 11,
    className = '',
  } = props;
  const [value, setValue] = useState('');
  const [rows, setRows] = useState(minRows);
  const inputRef = useRef<any>(null);

  const updateRow = useCallback(() => {
    if (!inputRef.current) return;

    const target = inputRef.current as HTMLTextAreaElement;
    const prevRows = target.rows;
    target.rows = minRows;

    // eslint-disable-next-line no-bitwise
    const currentRows = ~~(target.scrollHeight / 22); // 22是文字行高
    if (currentRows === prevRows) {
      target.rows = currentRows;
      return;
    }
    if (currentRows >= maxRows) {
      target.rows = maxRows;
      target.scrollTop = target.scrollHeight;
    }
    setRows(currentRows < maxRows ? currentRows : maxRows);
  }, [inputRef, maxRows, minRows]);
  useEffect(() => {
    if (value === '') {
      setRows(1);
    } else {
      updateRow();
    }
  }, [updateRow, value]);

  // 发送按钮
  const handleSend = () => {
    value && value.trim() && onSend?.(value);
    // 发送后, 输入框置空
    setValue('');
  };
  // shift+enter 换行
  const handleInputKeyDown = (event) => {
    if (event.shiftKey && event.keyCode === 13) {
      // 阻止默认行为
      event.preventDefault();
      // shift+enter 换行
      const textarea = inputRef.current;
      // 插入换行
      const cursorPosition = textarea.selectionStart;
      const currentValue = textarea.value;
      textarea.value = `${currentValue.substring(0, cursorPosition)}\n${currentValue.substring(cursorPosition)}`;
      textarea.setSelectionRange(cursorPosition + 1, cursorPosition + 1);
      setValue(textarea.value);
    }
  };
  // 回车
  const handlePressEnter = (value, event) => {
    //  在等待回复的时候, 禁用回车发送功能
    if (!showStop) handleSend();
    event.preventDefault();
  };
  return (
    <div className={`${className} chat-input ${showStop ? 'dbl-chat-input-disabled' : ''}`}>
      <Input.TextArea
        ref={inputRef}
        className={'chat-input-textArea'}
        rows={rows}
        value={value}
        onChange={(value) => setValue(value)}
        onKeyDown={handleInputKeyDown}
        onPressEnter={handlePressEnter}
        placeholder={text2sqlFormat('chat_input_placeholder')}
        disabled={showStop}
      />
      {showStop ? (
        ''
      ) : value ? (
        <Button className={'chat-input-btn chat-input-btn-send'} type="primary" onClick={handleSend}>
          <SvgIcon type={'datalab-send'} />{' '}
        </Button>
      ) : (
        ''
      )}
    </div>
  );
});
